import React from 'react'

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Paper,
    Divider,
} from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import DeleteIcon from '@material-ui/icons/Delete'

interface DeleteLineItemDialogProps {
    open: boolean
    onClose: () => void
    onConfirm: () => void
    lineItemDescription: string
    isLoading?: boolean
}

export const DeleteLineItemDialog: React.FC<DeleteLineItemDialogProps> = ({
    open,
    onClose,
    onConfirm,
    lineItemDescription,
    isLoading = false,
}) => {
    const handleConfirm = () => {
        onConfirm()
        onClose()
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: 12,
                },
            }}
        >
            <DialogTitle style={{ paddingBottom: 8 }}>
                <Box display="flex" alignItems="center">
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        width={40}
                        height={40}
                        borderRadius="50%"
                        bgcolor="error.light"
                        mr={2}
                    >
                        <WarningIcon style={{ color: 'white', fontSize: 20 }} />
                    </Box>
                    <Typography variant="h6" style={{ fontWeight: 600 }}>
                        Delete Line Item
                    </Typography>
                </Box>
            </DialogTitle>

            <Divider />

            <DialogContent style={{ paddingTop: 24, paddingBottom: 24 }}>
                <Typography
                    variant="body1"
                    gutterBottom
                    style={{ marginBottom: 16 }}
                >
                    Are you sure you want to delete this line item? This action
                    cannot be undone.
                </Typography>

                <Paper
                    elevation={0}
                    style={{
                        padding: 16,
                        backgroundColor: '#f5f5f5',
                        border: '1px solid #e0e0e0',
                        borderRadius: 8,
                    }}
                >
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        gutterBottom
                    >
                        Item to delete:
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                        {lineItemDescription}
                    </Typography>
                </Paper>
            </DialogContent>

            <Divider />

            <DialogActions style={{ padding: '16px 24px' }}>
                <Button
                    onClick={onClose}
                    disabled={isLoading}
                    style={{ marginRight: 8 }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    color="secondary"
                    variant="contained"
                    disabled={isLoading}
                    startIcon={<DeleteIcon />}
                    style={{
                        backgroundColor: '#d32f2f',
                        borderRadius: 6,
                        textTransform: 'none',
                        fontWeight: 500,
                        padding: '8px 16px',
                    }}
                >
                    {isLoading ? 'Deleting...' : 'Delete Item'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
